import { t } from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import ClipboardCopy from '../common/clipboard_copy/main';

import { PasskeyCopyProps } from './types';

// ===== STYLED COMPONENTS =====

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .bff-copy {
    font-size: 14px;
    color: #6c757d;
  }
`;

// ===== MAIN COMPONENT =====

/**
 * PasskeyCopy Component - Reusable copy button for passkeys
 *
 * Provides a standardized way to copy passkeys across privacy settings components.
 * Uses the existing ClipboardCopy component for consistent clipboard functionality.
 */
const PasskeyCopy: React.FunctionComponent<PasskeyCopyProps> = ({
  passkey,
  showFeedbackAsTooltip = false,
  title = t`Copy passkey`,
}) => {
  return (
    <ClipboardCopy
      showFeedbackAsTooltip={showFeedbackAsTooltip}
      textToCopy={passkey}
    >
      <IconButton
        title={title}
        type="button"
      >
        <span className="bff-copy" />
      </IconButton>
    </ClipboardCopy>
  );
};

export default PasskeyCopy;
